export default __webpack_public_path__ + "static/media/fan-club-logo.ea8e6fc2.svg";